module.exports = __webpack_public_path__ + "img/Drink Icon - charcoal.0779ba26.svg";